"use strict";

exports.__esModule = true;
exports.useTest = exports.useFeature = exports.loadSession = exports.context = exports.DarwinProvider = exports.Consumer = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SESSION_KEY = "__kwd_tests";
const loadSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw === null) {
      return {};
    }
    return JSON.parse(raw);
  } catch (e) {
    return {
      __error: String(e)
    }; // Differenciates between error and empty state
  }
};
exports.loadSession = loadSession;
const saveSession = test => {
  const current = loadSession();
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({
    ...current,
    [test.name]: test.value
  }));
};
const deleteSession = test => {
  const current = loadSession();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const {
    [test.name]: _,
    ...rest
  } = current;
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(rest));
};
const context = exports.context = /*#__PURE__*/React.createContext({
  onTest: () => null,
  onFeature: () => false
});
const {
  Provider,
  Consumer
} = context;
exports.Consumer = Consumer;
const DarwinProvider = _ref => {
  let {
    tests,
    features = {},
    winners = [],
    onTest,
    children
  } = _ref;
  const handleTest = React.useCallback(name => {
    const winner = winners.find(w => w.name === name);
    if (winner != null) {
      if (typeof window !== "undefined" && name in loadSession()) {
        deleteSession(winner);
      }
      return winner.value;
    }

    // Actual test visited
    const test = tests.find(t => t.name === name);
    if (test == null) {
      return null;
    }
    if (typeof window !== "undefined" && !(loadSession()[name] === test.value)) {
      saveSession(test);
      onTest === null || onTest === void 0 ? void 0 : onTest(test);
    }
    return test.value;
  }, [tests, winners, onTest]);
  const handleFeature = React.useCallback(name => {
    return name in features ? features[name] : false;
  }, [features]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      onTest: handleTest,
      onFeature: handleFeature
    }
  }, children);
};
exports.DarwinProvider = DarwinProvider;
const useDarwin = () => React.useContext(context);
const useTest = name => {
  const {
    onTest
  } = useDarwin();
  return onTest(name);
};
exports.useTest = useTest;
const useFeature = name => {
  const {
    onFeature
  } = useDarwin();
  return onFeature(name);
};
exports.useFeature = useFeature;